import moment from 'moment';
import { instBundle } from '@/axios.js';
import util from '@/util.js';

const axiosAdmin2 = instBundle.axiosAdmin2;

const state = {
	idEvent: null,
	paramsModel: {
		nickName: '',
		createDateRange: ['', ''],
		eventReply: '',
	},
	nickName: '',
	createDateRange: ['', ''],
	eventReply: '',
	orderList: [
		{ value: 1, name: '최근등록순' },
		{ value: 2, name: '이전등록순' },
		{ value: 3, name: '노출순' },
		{ value: 4, name: '비노출순' },
	],
	order: 1,
	limitList: [
		{ value: 10, name: '10개씩' },
		{ value: 20, name: '20개씩' },
		{ value: 30, name: '30개씩' },
		{ value: 40, name: '40개씩' },
		{ value: 50, name: '50개씩' },
	],
	limit: 10,
	offset: 0,
	commentList: null,
	totalData: null,
};

const getters = {
	getParams() {
		const params = {};
		const paramsModel = state.paramsModel;
		for (let key in paramsModel) {
			const stateValue = state[key];
			if (
				key === 'createDateRange' &&
				stateValue.every(eventDate => eventDate)
			) {
				params[key] = stateValue.map((date, idx) =>
					idx === 0
						? moment(date, 'YYYY-MM-DD').format('x')
						: moment(date, 'YYYY-MM-DD').endOf('date').format('x')
				);
			} else if (key !== 'createDateRange') {
				params[key] = stateValue;
			}
		}
		params.order = state.order;
		params.limit = state.limit;
		params.offset = state.offset;
		return params;
	},
	parsedCommentList() {
		if (!state.commentList) return null;
		const list = JSON.parse(JSON.stringify(state.commentList));
		return list.map(item => {
			item.createdDate = moment(item.createdDate * 1000).format(
				'YYYY-MM-DD HH:mm'
			);
			item.isDisplayMsg =
				item.isDisplay === true ? '비노출 처리' : '노출처리';
			return item;
		});
	},
};

const mutations = {
	idEvent(state, id) {
		state.idEvent = id;
	},
	commit(state, commitList) {
		commitList.forEach(commitObj => {
			state[commitObj.key] = commitObj.value;
		});
	},
	initFilter() {
		const initModel = state.paramsModel;
		for (let key in initModel) {
			state[key] = initModel[key];
		}
	},
};

const actions = {
	async getCommentList({ state, getters }) {
		try {
			const params = getters.getParams;
			const totalData = await axiosAdmin2.post(
				`/api/event/${state.idEvent}/reply/total`,
				params
			);
			state.totalData = totalData.data.totalData;
			const { data } = await axiosAdmin2.post(
				`/api/event/${state.idEvent}/reply`,
				params
			);
			state.commentList = data.data;
		} catch (err) {
			console.error(err);
		}
	},
	changeImmediately({ dispatch }, { key, value }) {
		state.offset = 0;
		state[key] = value;
		dispatch('getCommentList');
	},
	async toggleDisplay({ dispatch }, { idEvent, idEventReply, isDisplay }) {
		try {
			await axiosAdmin2.put(
				`/api/event/${idEvent}/reply/${idEventReply}?isDisplay=${isDisplay}`
			);
			dispatch('getCommentList');
		} catch (err) {
			console.error(err);
		}
	},
	async deleting({ dispatch }, { idEvent, idEventReply }) {
		try {
			await axiosAdmin2.delete(
				`/api/event/${idEvent}/reply/${idEventReply}`
			);
			dispatch('getCommentList');
		} catch (err) {
			console.error(err);
		}
	},
	offset({ state, dispatch }, offset) {
		state.offset = offset;
		dispatch('getCommentList');
	},
	async excelDown({ state, rootState }) {
		try {
			const params = {
				order: 1,
				limit: 10000000000,
				offset: 0,
			};
			const {
				data: { data },
				config,
			} = await axiosAdmin2.post(
				`/api/event/${state.idEvent}/reply`,
				params
			);
			if (data.length < 1) {
				alert('데이터가 없습니다');
				return;
			}
			const rows = data.map(item => [
				moment(item.createdDate * 1000).format('YYYY-MM-DD HH:mm'),
				item.idRegister,
				item.nickName,
				item.eventReply,
				item.isDisplay ? '노출' : '비노출',
			]);
			const title = `이벤트 댓글 리스트 (${rootState.modal.modalTitle})`;
			util.getCsv(
				[rows],
				[title],
				[['등록일시', '회원번호', '닉네임', '내용', '노출상태']],
				`글로우픽_${title}_${new Date().getTime()}`,
				config.url
			);
		} catch (err) {
			console.error(err);
			alert(
				'엑셀 파일을 다운로드하는데 실패했습니다. 개발팀에 문의하세요.'
			);
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
